import { useState } from 'react';
import { useAtom } from 'jotai';
import { db } from '../services/firebase';
import { modulesAtom } from '../state/atoms';

function useGetModules() {
  const [, setModules] = useAtom(modulesAtom);
  const [isLoading, setIsLoading] = useState(false);

  const getModules = async () => {
    setIsLoading(true);
    const modulesSnapshot = await db.collection('Modules').get();
    const modulesData = modulesSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setModules(modulesData);
    setIsLoading(false);
  };
  return { getModules, isLoading };
}

export default useGetModules;
